export default "__VITE_ASSET__BO9a5Xjd__"